export class Subject {
  component = null;
  constructor(component) {
    this.component = component;
  }
  next(event: { type: any }) {
    switch (event.type) {
      case "TEST_READY": {
        this.component.setState({
          isGameLoading: false,
        });

        // FOR TRIVIA HARD CODE
        const url = new URL((window as any).location.href);
        if (
          url.searchParams.get("toGo") &&
          (this.component.props.game.slug === "aarp-trivia" ||
            this.component.props.game.slug === "aarp-trivia-sports")
        ) {
          setTimeout(() => {
            window.dispatchEvent(new CustomEvent("ExternalPrerollEnd"));
          }, 3000);
        }
        break;
      }
      case "CHANGE_SCORE":
        this.component.props.onScoreChange &&
          this.component.props.onScoreChange(event);
        break;
      case "REWARD_START":
        this.component.props.onReward && this.component.props.onReward(event);
        break;
      case "GAME_END":
        document.body.style.overflow = "auto";
        this.component.props.onGameEnd && this.component.props.onGameEnd(event);
        break;
      case "REDEEM_POWERUP":
        this.component.props.onPowerUp && this.component.props.onPowerUp(event);
        break;
      case "OPT_LOG_IN":
        this.component.props.onOptInLogin &&
          this.component.props.onOptInLogin(event);
        break;
      default:
        break;
    }
  }
  subscribe() {}
}
